import { createAction, props } from '@ngrx/store';
import { Error, ErrorConfiguration, ErrorDisplay } from '../models/error.model';

// init
export const init = createAction('[Error] Init');

export const loadErrorsSuccess = createAction(
  '[Error] Load successfully the user errors',
  props<{ errors: Array<Error> }>()
);
export const loadErrorsError = createAction('[Error] Load past errors failure');

// core

export const resetState = createAction('[Error] Reset state instruction');

// configure display list

export const updateConfig = createAction(
  '[Error] update display configuration of error list',
  props<{ errorConfig: ErrorConfiguration }>()
);

// set error list

export const saveError = createAction('[Error] Add or update an error in the store', props<{ error: Error }>());
export const saveErrorSuccess = createAction('[Error] Error successfully saved', props<{ error: Error }>());
export const saveErrorError = createAction('[Error] Failed to save the error');

// error actions
export const searchTemplate = createAction('[Error] Search amont error templates', props<{ search: string }>());
export const updateDisplay = createAction('[Error] Update the error display mode', props<{ display: ErrorDisplay }>());

export const selectError = createAction('[Error] Set this error as main target', props<{ error: Error }>());
export const syncNewError = createAction('[Error] Sync a new error from backend', props<{ error: Error }>());
//export const solveError = createAction('[Error] Trigger error saving with solved flag', props<{ error: Error }>());
